@if(multiSelector){
<div style="width: 300px">
  <label class="f-small text-neutral-800 mb-1" for="selectFrameworkId">{{label || 'Regulatory Standards Framework'}}</label>
  <app-customised-multi-select id="selectFrameworkId" controlName="framework" [controls]="controls"
    [submitted]="submitted" [options]="options" [autoGrow]="false" displayName="Framework"
    [savedFilter$]="savedFilter$"
    [showNumOnSelectAll]="true"></app-customised-multi-select>
</div>
} @else {
<div style="width: 450px">
  <label class="f-small text-neutral-800 mb-1" for="selectFrameworkId">{{label || 'Regulatory Standards Framework'}}</label>
  <app-customised-single-select id="selectFrameworkId" controlName="framework" [autoGrow]="false"
    [submitted]="submitted" [controls]="controls" [options]="options"
    displayName="Framework"></app-customised-single-select>
</div>
}